import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

const TestComponent = () => {
    const [jsonData, setJsonData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('https://api.tarrouche.biz/');
                const data = await response.json();
                setJsonData(data);
            } catch (err) {
                console.error('Error fetching data:', err);
                setError('Impossible de contacter le service pour le moment.');
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <div className="page-header">
                <span className="page-eyebrow">Diagnostic</span>
                <h1 className="page-title">État du service</h1>
                <p className="page-subtitle">Vérifie la connexion à l’API Tarrouche.</p>
            </div>

            <div className="panel">
                <div className="panel-section">
                    {error ? (
                        <div className="field-alert">
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                            {error}
                        </div>
                    ) : jsonData ? (
                        <pre style={{ margin: 0, fontSize: '0.85rem' }}>{jsonData.message}</pre>
                    ) : (
                        <span className="status-msg">
                            <FontAwesomeIcon icon={faCircleNotch} spin className="me-2" />
                            Chargement des données…
                        </span>
                    )}
                </div>
            </div>
        </>
    );
};

export default TestComponent;
